import { CreationToolFrame } from '../types'

/**
 * Returns the canvas to display from a list of frames accounting for the frameCount property.
 * @param frames An array of creation tool frames to display.
 * @param drawCount The current draw count sent via the draw method in the creation canvas.
 */
const getCurrentFrameCanvas = (frames: CreationToolFrame[], drawCount: number = 0): HTMLCanvasElement | undefined => {
    if (!frames.length) {
        return
    }

    // create an array of frame indexes that accounts for the frame's span
    const indexes: number[] = []
    frames.forEach(({ frameCount = 1 }, i) => {
        for (let f = 0; f < frameCount; f++) {
            indexes.push(i)
        }
    })

    const activeIndex = drawCount % indexes.length
    const { canvas } = frames[indexes[activeIndex]]
    return canvas
}

export default getCurrentFrameCanvas
